import { ConnectionIndicator as FoundationConnectionIndicator, foundationConnectionIndicatorTemplate as template, foundationConnectionIndicatorStyles as styles, } from '@genesislcap/foundation-ui';
/**
 * @tagname %%prefix%%-connection-indicator
 */
export class ConnectionIndicator extends FoundationConnectionIndicator {
}
export const zeroConnectionIndicator = ConnectionIndicator.compose({
    baseName: 'connection-indicator',
    template,
    styles,
});
